import { createSlice } from "@reduxjs/toolkit";

export const tableSlice = createSlice({
	name: "table",
	initialState: {
		arrayData: [],
		headersTable: [],
		correctAnswers: [],
	},
	reducers: {
		onSetArrayData: (state, { payload }) => {
			state.arrayData = payload;
            console.log("descomentar para Data formated: ");
            // console.log("Data formated: ", state.arrayData);
		},
		onSetArrayHeaders: (state, { payload }) => {
			state.headersTable = payload;
            // console.log("headers", state.headersTable);
		},
		onSetArrayAnswers: (state, { payload }) => {
			state.correctAnswers = payload;
            // console.log("correct answers", state.correctAnswers);
		},
	},
});

export const { onSetArrayData, onSetArrayHeaders, onSetArrayAnswers } = tableSlice.actions;
